import { injectIntl } from 'react-intl';
import React from 'react';
import AdminRoutePlanRefresh from './adminRoutePlanRefresh';
import { useRoutePlan } from './apiHooks';
import Loader from '../../components/loader';
import ErrorMessage from '../../components/errorMessage';
import utils from '../../utils/utils';
import AdminRouteOptimisationPlanEdit from './adminRoutePlanEdit';

const AdminRoutePlanV2Optimise = ({ pickupSlot, deliveryDay }) => {
  const {
    isLoading: isRoutePlanLoading,
    isError: isRoutePlanError,
    error: routePlanError,
    routePlan,
  } = useRoutePlan({
    routePlanSetupPickupSlotId: pickupSlot?.id,
  });

  return (
    <div>
      <Loader show={isRoutePlanLoading} />
      {isRoutePlanError ? <ErrorMessage error={utils.getErrorMessageFromResponse(routePlanError)} /> : ''}

      {routePlan?.routeOptimisationResult && routePlan.routeOptimisationResult.status !== 'SUCCEED' ? (
        <AdminRoutePlanRefresh routePlan={routePlan} />
      ) : routePlan ? (
        <AdminRouteOptimisationPlanEdit
          selectedDeliveryDay={deliveryDay}
          routePlan={routePlan}
          routePlanSetupId={pickupSlot?.routePlanSetupId}
        />
      ) : (
        ''
      )}
    </div>
  );
};

export default injectIntl(AdminRoutePlanV2Optimise);
